export const COOKIE_CUSTOMER_INFO = "ml2_sid_c";
export const COOKIE_CUSTOMER_SESSION_ID = "ml_s";
export const CUSTOMER_STORAGE_DATA = "nationalCustomerData";
export const FBC_COOKIE = "_fbc";
export const FBP_COOKIE = "_fbp";
export const GA_COOKIE = "_ga";
export const GUEST_DOCUMENT = "fromGuestDocument";
export const TRUNCATED_LOGIN_INFO_STORAGE_KEY = "truncatedLoginInfo";
export const ZIPCODE = `zipcode`;
export const ZIPCODE_CITY = `zipcode_city`;
export const ZIPCODE_STATE = `zipcode_state`;
